import { useInfiniteQuery } from '@tanstack/react-query';

import { QuizKey } from './keys';
import { QuizService } from './quizService';

export function useGetQuizzesInfinite(name?: string, enabled: boolean = true) {
  return useInfiniteQuery({
    queryKey: [QuizKey.ASSIGNED_QUIZZES_INFINITE, name],
    enabled: enabled,
    queryFn: ({ pageParam }) => QuizService.getQuizzes({ ...pageParam, name: name }).then((response) => response.data),
    initialPageParam: { page: 0, pageSize: 20, name: undefined },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) {
        return undefined;
      }
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
  });
}
